@if (isVisible) {
  <div>
    @if (showloader) {
      <div class="loading" >
        <div class="loading_txt">
          <div class="load_txt">{{"returnsUK.loadinglabel" | cxTranslate}}</div>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    }
    <div class="col-xs-12 col-md-12 col-lg-12 no-padding UkCreateReturn" >
      @if (!noReturnThanks) {
        <section class="col-md-12 no-padding newReturnText" >
          <div class="col-md-6 newReturns_subheader">
            {{"returnsUK.verifynoreturn" | cxTranslate}}
          </div>
        </section>
      }
      @if (noReturnlanding) {
        <section class="col-xs-12 ReturnSelectLocation" id="newReturn_selectlocation" >
          <div class="newReturn_selectparent " id="newReturn_selectlocation-1" >
            <div class="newReturn_selectbox">
              <div class="col-xs-12 col-md-8 no-padding newReturn_selectheader">Select Locations<div class="createSelText">{{"returnsUK.noreturnlocmsg" | cxTranslate}}</div></div>
              <div class="col-xs-12 col-md-4 no-padding newReturn_selectcount">Verify: <span class="newReturn_loccount">{{ selectedCount }}</span>&nbsp;<span>location(s)</span></div>
              <div class="col-xs-12 cart_selectline"></div>
              <div class="clearboth"></div>
              <div class="col-xs-12 newreturn_selectoptions">
                <div class="newReturn_customsearch">
                  <i class="global_searchicon"></i><input type="search" placeholder="Search for location" id="newreturn_searchbox" (keyup)="applyFilter($event)"><button (click)="applyFilter($event)">Search</button>
                </div>
                <div class="newReturn_selectunselect">
                  <div class="newReturn_selectoption" id="newReturn_selectall" (click)="selectAll()">Select All</div><div class="newReturn_selectdivision"></div><div class="newReturn_selectoption" id="newReturn_clearall" (click)="clearAll()">Clear Selections</div>
                </div>
              </div>
              <div class="table-container">
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                  <!-- Checkbox Column -->
                  <ng-container matColumnDef="checked">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox (change)="toggleAllRows($event)"></mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let element"  >
                      @if (element.checked === 'false') {
                        <span class="return_unavbl">{{"returnsUK.returnunavailable" | cxTranslate}}</span>
                      }
                      @if (element.checked === 'true') {
                        <span></span>
                      }
                      @if (element.checked === 'myReturn') {
                        <span class="return_link" (click)="navigateToReturns($event, element)">{{"returnsUK.seereturntxt" | cxTranslate}}</span>
                      }
                    </td>
                  </ng-container>
                  <!-- Location Name Column -->
                  <ng-container matColumnDef="locname">
                    <td mat-cell *matCellDef="let element"> {{element.locname}} </td>
                  </ng-container>
                  <!-- Address Column -->
                  <ng-container matColumnDef="address">
                    <td mat-cell *matCellDef="let element"> {{element.address}} </td>
                  </ng-container>
                  <!-- State Column -->
                  <ng-container matColumnDef="state">
                    <td mat-cell *matCellDef="let element"> {{element.state}} </td>
                  </ng-container>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClick(row)" [ngClass]="{
                'non_selectable': row.checked === 'false',
                'selected-row': selection.isSelected(row),
                'non_selectable_return': row.checked === 'myReturn'
              }"></tr>
                </table>
              </div>
              @if (dataSource.filteredData.length === 0) {
                <div class="norecord">
                  {{"returnsUK.norecordsmsg" | cxTranslate}}
                </div>
              }
            </div>
            <div class="newReturn_startorderbtnsection">
              <a class="newReturn_exitBtn returnPopupshow" (click)="openExistpopup()">{{"returnsUK.exitlabel" | cxTranslate}}</a>
              <button type="submit" class="newReturn_startorderbtn" id="toproductpage" [disabled]="selectedCount === 0"(click)="submitSelectedRows()" >Review Locations</button>
            </div>
          </div>
        </section>
      }
      @if (noReturnsetails) {
        <section class="col-xs-12">
          <div class="Reviewbox">
            <div class="noreturnbackbox">
              <div class="NoReturnback" (click)="showNoreturnlanding()">
                <div class="global_blackarrow"></div>
                {{"returnsUK.backtoloctxt" | cxTranslate}}
              </div>
              <div class="noReturn_selectcount">Verify: <span class="newReturn_loccount">{{ selectedCount }}</span>&nbsp;<span>location(s)</span></div>
            </div>
            <div class="greyline"></div>
            <div class="Reviewsubtext">{{"returnsUK.reviewlocnoreturn" | cxTranslate}}</div>
            <div class="greyline"></div>
            <div class="Reviewtablebox">
              <table class="selectedlocdetails">
                @for (row of selectedRows; track row) {
                  <tr class="reviewlocation">
                    <td>{{row.locname}}</td>
                    <td>{{row.address}}</td>
                    <td>{{row.state}}</td>
                    <td class="selectedtick"></td>
                  </tr>
                }
              </table>
            </div>
          </div>
          <!-- //bottom submit btn -->
          <div class="ReviewconfirmSection">
            <div class="completetext">{{"returnsUK.completenoreturn" | cxTranslate}}</div>
            <div class="row">
              <div class="Returnsubmitbox col-md-7 leftside">
                <label class="Retunrcheck-button">
                  <input type="checkbox" class="Return_check" id="NoReturncheck" name="NoReturncheck" [(ngModel)]="checkboxChecked" (change)="onCheckboxChange()">
                  <span class="Retuncheck-button__control"></span>
                  <label class="Returnlabeltext">
                    {{"returnsUK.noreturnsmsg" | cxTranslate}}
                  </label>
                </label>
                @if (checkboxErrorMessage) {
                  <label id="imagecheck0-error" class="error help-block" for="imagecheck0"><i class="fa-solid fa-circle-exclamation"></i>&nbsp;{{ checkboxErrorMessage }}</label>
                }
                <div class="clearboth"></div>
              </div>
              <div class="NoReturnbtnsection col-md-5 no-padding-right">
                <a class="NoReturn_exit returnPopupshow" (click)="openExistpopup()">{{"returnsUK.exitlabel" | cxTranslate}}</a> <button type="button" class="confirmbtn" id="ConfirmReturn" (click)="validateNoreturnForm()" >{{"returnsUK.confirmnoreturn" | cxTranslate}}</button>
              </div>
            </div>
          </div>
          <div>
          </div>
        </section>
      }
      @if (noReturnThanks) {
        <section class="col-xs-12 col-md-12" id="NoReturnThank">
          <div class="Returnthank_box">
            <div class="thankReturn_head">{{"returnsUK.thankyoumsg" | cxTranslate}}</div>
            <div class="thankreturn_text">{{"returnsUK.emailconfirmsg" | cxTranslate}}</div>
            <a class="nopopshow returnPopupshow" (click)="goToreturn()">
              <div class="Returnbutton">View Returns</div>
            </a>
          </div>
          <!-- <app-custom-returns-thankyouvideo></app-custom-returns-thankyouvideo>
          <app-custom-returns-thankyoumaterials></app-custom-returns-thankyoumaterials>
          <app-custom-picture-resources></app-custom-picture-resources> -->
        </section>
      }
    </div>
  </div>
}